<template>
	<v-container>
		<v-row>
			<v-col cols="12" lg="6">
				<AccountCard v-model="account" :skeleton="skeleton" />
				<TransactionHistoryListingCard class="mt-8" v-model="transactionHistory" :skeleton="skeleton" />
			</v-col>
			<v-col cols="12" lg="6">
				<VirtualWalletListingCard :value="virtualWallets" :skeleton="skeleton" :user="account" @created="handleVirtualWalletCreated" />
				<ConnectedAccountListingCard class="mt-8" v-model="connectedAccounts" :skeleton="skeleton" @refresh="handleRefresh" />
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import AccountCard from '@/components/AccountCard';
import TransactionHistoryListingCard from '@/components/TransactionHistoryListingCard';
import VirtualWalletListingCard from '@/components/VirtualWalletListingCard';
import ConnectedAccountListingCard from '@/components/ConnectedAccountListingCard';
import { AccountModel, EComService, PaginationModel } from '@connectngo/sdk';

export default {
	name: 'Index',

	metaInfo() {
		return {
			title: this.$i18n.t('route.account'),
			meta: [
				{ property: 'og:title', content: this.$i18n.t('route.account') },
				{ property: 'og:url', content: window.location.href },
			],
		};
	},

	components: { AccountCard, TransactionHistoryListingCard, VirtualWalletListingCard, ConnectedAccountListingCard },

	data: () => ({
		skeleton: true,
		loading: false,
		account: new AccountModel(),
		transactionHistory: new PaginationModel(),
		virtualWallets: new PaginationModel(),
		connectedAccounts: new PaginationModel(),
	}),

	methods: {
		handleRefresh() {
			this.load();
		},
		handleVirtualWalletCreated(wallet) {
			this.$snack(this.$i18n.t('virtualWallet.created'));
			this.virtualWallets.results.unshift(wallet);
		},
		load() {
			this.loading = true;
			return Promise.all([
				new EComService().getSession(),
				new EComService().getTransactionHistory(this.$root.user.data.id, {
					per_page: 5,
				}),
				new EComService().getVirtualWallets(this.$root.user.data.id, {
					per_page: 5,
				}),
				new EComService().getConnectedAccounts(this.$root.user.data.id),
			])
				.then(([account, transactionHistory, virtualWallets, connectedAccounts]) => {
					Object.assign(this, { account, transactionHistory, virtualWallets, connectedAccounts });
					this.skeleton = false;
				})
				.catch(reason => this.$handleError(this, reason))
				.finally(() => (this.loading = false));
		},
	},

	created() {
		this.load();
	},
}
</script>
